"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function onhashchange(listener) {
    var lastHash = location.hash || '';
    var call = function () {
        var hash = location.hash;
        if (lastHash === hash)
            return;
        lastHash = hash;
        listener(hash);
    };
    var intervalId = window.setInterval(call, 30);
    window.addEventListener('hashchange', call);
    return function () {
        window.clearInterval(intervalId);
        window.removeEventListener('hashchange', call);
    };
}
exports.onhashchange = onhashchange;
